<app-verify-email [changePasswordUrl]="'/auth/resetPassword/changePassword'"
                  [loginUrl]="'/auth/login'"></app-verify-email>
